import styled from "@emotion/styled";

const WrapperRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.space[6]}px;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    flex-direction: row;
    gap: ${p => p.theme.space[6]}px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${p => p.theme.space[5]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    gap: 20px;
  }
`;

const Form = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${p => p.theme.space[6]}px;
  margin-top: ${p => p.theme.space[7]}px;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    width: max-content;
    flex-direction: row;
    margin-top: 0;
  }
`;

const Title = styled.p`
  font-size: 26px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 42px;
    font-weight: 700;
  }
`;

const Text = styled.p`
  font-size: 16px;
  line-height: 1.63;
  color: ${({ theme }) => theme.colors.secondary.minor};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 18px;
    line-height: 1.78;
  }
`;

export { WrapperRoot, Wrapper, Form, Title, Text };
